<template>
    <div class="flex-3 marginT-20">
        <el-form ref="form" :model="form" label-width="130px" label-position="left">
            <div class="mark-group">
                <el-form-item label="打标拼多多账号：">
                    <el-input
                        v-model="user_ids"
                        placeholder="请输入拼多多账号id或者账号分享链接">
                    </el-input>
                </el-form-item>
                <el-form-item label="打标商品：">
                    <el-input v-model="product_ids" placeholder="请输入商品链接或者商品id">
                    </el-input>
                </el-form-item>
            </div>
            <el-form-item>
                <span class="fc-666">必须提交的是拼多多用户id号，获取用户id相关流程，<span class="point fc-theme" @click="intro">点击查看</span> </span>
                <br>
                <el-button type="danger" @click="onSubmit">提交查询</el-button>
            </el-form-item>
        </el-form>
        <intro v-if="showIntro" v-model="showIntro"></intro>
    </div>
</template>

<script>
import intro from './intro';
export default {
    components: {
        intro,
    },
    data() {
        return {
            showIntro: false,
            user_ids: undefined,
            product_ids: undefined,
            form: {
                type: 1,
                user_ids: undefined,
                product_ids: undefined
            },
        }
    },
    methods: {
        onSubmit() {
            window.checkDiscountPackage("pddforcescreen")
            if (!this.user_ids || !this.product_ids) {
                this.$message.error('请填写完整')
                return
            }
            if (this.user_ids && this.user_ids.indexOf('http') > -1) {
                if (this.user_ids.indexOf('share_uid') == -1) {
                    this.$message.error('未找到拼多多账号')
                    return
                }
                try {
                    const url = new URL(this.user_ids.replace(/ /g, ''))
                    const accountId = this.getQueryVariable(url, 'refer_share_uid')
                    this.form.user_ids = accountId
                } catch (error) {
                    this.$message.error('未找到拼多多账号')
                    return
                }

            } else {
                this.form.user_ids = this.user_ids.replace(/ /g, '')
            }
            if (this.product_ids && this.product_ids.indexOf('http') > -1) {
                if (this.product_ids.indexOf('goods_id') == -1) {
                    this.$message.error('未找到商品ID')
                    return
                }
                try {
                    const url = new URL(this.product_ids.replace(/ /g, ''))
                    const productId = this.getQueryVariable(url, 'goods_id')
                    this.form.product_ids = productId
                } catch (error) {
                    this.$message.error('未找到商品ID')
                    return
                }
            } else {
                this.form.product_ids = this.product_ids.replace(/ /g, '')
            }
            this.submit()
        },
        intro() {
            if (this.isToolMainSite()) {
                window.open('http://ask.vv-tool.com/article/3306')
            } else {
                this.showIntro = true
            }
        },
        async submit() {
            const data = await this.$fetch('/api/proxy/web/pddforcescreen', this.form, 'post')
            console.log({data});
            if (data.code == 0) {
                this.$message.success('提交成功')
                this.$emit('refreshRecode')
            }
        }
    },
}
</script>

<style lang="scss" scoped>

</style>
